import { Col, Container, Row } from "reactstrap";
import React, { useEffect, useState } from "react";
import {
  getuserProfileDetail,
  viewKyc,
} from "./../../../service/user-detail-service";
import { useHistory, useLocation } from "react-router-dom";

import NkHeader from "../../../common/nkheader";
import Profile from "./profile";
import RakProfileCreateHistory from "./rakprofilecreatehistory";
import Status from "./status";
import UserDetail from "./userdetail";
import VasServicesTab from "./VasServicesTab";
import UpdateEidNumber from "./modals/update-EID-number";
import { getUserRoleName } from "../../azureLogin/authUtility";

const ProfileDetailsPage = () => {
  const [allUsersObject, setAllUsersObject] = useState([]);
  const [kycDetail, setKycDetail] = useState();
  const { state } = useLocation();
  const history = useHistory();
  const [profileloading, setProfileloading] = useState(false);
  const [eidUpdateModal, setEidUpdateModal] = useState(false);
  useEffect(() => {
    if (state && state.id) {
      getuserProfileDetailById(state.id);
    } else {
      history.push("/admin/registered-users");
    }
  }, [state && state.id]);
  useEffect(() => {
    if (allUsersObject.isKYCUploaded) {
      getKycDetail(state.id);
    }
  }, [allUsersObject]);

  const getuserProfileDetailById = (id) => {
    setProfileloading(true);
    getuserProfileDetail(id)
      .then((res) => {
        setProfileloading(false);
        setAllUsersObject(res && res.data);
      })
      .catch((err) => {
        console.log(err);
        setProfileloading(false);
        setAllUsersObject([]);
      });
  };

  const getBackMethod = (res) => {
    setAllUsersObject(res);
  };

  const getKycDetail = (id) => {
    viewKyc(id)
      .then((res) => {
        setKycDetail(res && res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const roleName = getUserRoleName()
  
  let isECSAgent = roleName === "ExternalCustomerServiceAgent";

  return (
    <>
      <Container className="mt--6 profile-con" fluid style={{ paddingTop: 60 }}>
        <NkHeader title="Profile" />
        <Row className="card-wrapper">
          <Col
            lg="3"
            style={{
              justifyContent: "space-between",
              display: "flex",
              flexDirection: "column",
              padding: "0px 5px 0px 10px",
            }}
          >
            <Profile
              allUsersObject={allUsersObject}
              profileloading={profileloading}
              kycDetail={kycDetail}
              setProfileloading={setProfileloading}
            />
            <Status
              allUsersObject={allUsersObject}
              id={state && state.id}
              getBackMethod={getBackMethod}
              profileloading={profileloading}
              setProfileloading={setProfileloading}
            />
          </Col>
          <Col lg="9" style={{ padding: "0px 5px" }}>
            <UserDetail
              dateFormat={allUsersObject.atmpinBlockDate}
              profileloading={profileloading}
              allUsersObject={allUsersObject}
              kycDetail={kycDetail}
              id={state && state.id}
              setProfileloading={setProfileloading}
              setEidUpdateModal={setEidUpdateModal}
            />
            <UpdateEidNumber
              show={eidUpdateModal}
              onHide={() => setEidUpdateModal(false)}
              oldEIDNumber={allUsersObject.emiratesId}
              cardHolderId={allUsersObject.citizenId}
              getuserProfileDetailById={getuserProfileDetailById}
            />
          </Col>
        </Row>
        {!isECSAgent ? (
          <Row className="card-wrapper">
            <Col lg="12" style={{ padding: "0px 5px 0px 10px" }}>
              <VasServicesTab
                allUsersObject={allUsersObject}
                userId={state && state.id}
              />
            </Col>
          </Row>
        ) : (
          ""
        )}
        <Row className="card-wrapper">
          <Col lg="12" style={{ padding: "0px 5px 0px 10px" }}>
            <RakProfileCreateHistory
              allUsersObject={allUsersObject}
              userId={state && state.id}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ProfileDetailsPage;
